<template>
  <Button
    color="text-primary"
    :title="$t('Sample reception')"
    :icon-btn="true"
    :icon-with-background="true"
    small
    class="ma-1"
    @click="$emit('click')"
  >
    <v-icon
      size="small"
      color="primary"
    >
      mdi-inbox-full
    </v-icon>
  </Button>
</template>

<script setup lang="ts">
import Button from "@/components/input-components/Button.vue";

defineOptions({ name: "OrderGridActionSampleReception" });

const emit = defineEmits(['click']);
</script>
